var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 883 131",
    width: 883,
    height: 131,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_stacked_primary") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #00245d } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m201.3 46.7l14.5 38.3h-7.9l-3-8.2h-16.1l-2.9 8.2h-7.9l14.4-38.3zm1.3 23.8l-5.8-16.2-5.7 16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m276.9 70l13.3 15h-9.7l-13.4-14.8h-2.2v14.8h-7.8v-38.3h16.7c8 0 13.2 4.7 13.2 12.1 0 6-3.9 10.2-10.1 11.2zm-3.4-5.8c3.4 0 5.6-2.1 5.6-5 0-3-2.2-5.2-5.6-5.2h-8.6v10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m339.3 65.6l15.9 19.4h9.5l-16.6-20.1 16-18.2h-9.5l-15.3 17.6v-17.6h-7.8v38.3h7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m431.6 61.4h-17.9v-14.7h-7.7v38.3h7.7v-16.4h17.9v16.4h7.7v-38.3h-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m504 46.7l14.5 38.3h-7.9l-2.9-8.2h-16.2l-2.9 8.2h-7.9l14.4-38.3zm1.3 23.8l-5.8-16.2-5.7 16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m594.5 46.7l-11.4 24.5-11.8-24.5h-11.4v38.3h7.8v-28.1l11.4 23.8h7.7l11.5-23.6v27.9h7.9v-38.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m681.2 46.7h-7.8v38.3h27.6v-7.2h-19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m765.8 46.7l14.5 38.3h-7.9l-3-8.2h-16.1l-2.9 8.2h-7.9l14.4-38.3zm1.3 23.8l-5.7-16.2-5.8 16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m865.1 74.3l-9.4-27.6h-8.1l-9.4 27.2-9.5-27.2h-8.3l14 38.3h8l9.2-27.5 9.5 27.5h7.8l14.1-38.3h-8.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m65.6 0.6c-35.7 0-64.8 29.1-64.8 64.8 0 18 7.4 34.2 19.2 46l0.2-0.5v-0.1l2.6-5.8c-9.7-10.4-15.6-24.3-15.6-39.6 0-32.2 26.2-58.4 58.4-58.4 32.2 0 58.4 26.2 58.4 58.4 0 32.2-26.2 58.4-58.4 58.4-11 0-21.2-3.1-30-8.4l-3.8 5.2c9.8 6.1 21.4 9.6 33.8 9.6 35.7 0 64.8-29.1 64.8-64.8 0-35.7-29.1-64.8-64.8-64.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m108.3 98.5c-1.6 2.8-3.7 4.6-5.9 5.9-1.9 1.3-6.2 3-6.2 3l-12.8-29.9 6.4-1.3 9.7 22.6c1.5-0.8 2.6-2.4 3.3-3.5 2.6-4.5 3.6-12.4 0.4-18-2.1-3.7-5.8-5.6-10.9-5.6-32.5 0-55.7 32.3-55.9 32.6l-16.7 23 45.9-104 19.5 42.5q3.5-0.5 7.2-0.5c7.3 0 13.1 3.1 16.4 8.8 4.5 7.8 3.2 18.2-0.4 24.4zm-29.7-31.6l-13-28.5-21.3 47.8c8.3-7.5 20-15.8 34.3-19.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo_horizontal.6b4c8793f71b480ebad35de920cad284.svg";
export { ForwardRef as ReactComponent };